import { render, staticRenderFns } from "./Savings.vue?vue&type=template&id=17e99779&scoped=true&"
import script from "./Savings.vue?vue&type=script&lang=js&"
export * from "./Savings.vue?vue&type=script&lang=js&"
import style0 from "./Savings.vue?vue&type=style&index=0&id=17e99779&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e99779",
  null
  
)

export default component.exports